/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoTokenRequest model module.
 * @module model/PerplayStatisticsControllerDtoTokenRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoTokenRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoTokenRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoTokenRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoTokenRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoTokenRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoTokenRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoTokenRequest} The populated <code>PerplayStatisticsControllerDtoTokenRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoTokenRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoTokenRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoTokenRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoTokenRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['transactionType'] && !(typeof data['transactionType'] === 'string' || data['transactionType'] instanceof String)) {
            throw new Error("Expected the field `transactionType` to be a primitive type in the JSON string but got " + data['transactionType']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoTokenRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoTokenRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoTokenRequest.prototype['endDate'] = undefined;

/**
 * @member {String} transactionType
 */
PerplayStatisticsControllerDtoTokenRequest.prototype['transactionType'] = undefined;






export default PerplayStatisticsControllerDtoTokenRequest;

